/*
 * General error handler on resolver failiure
 * <p>
 *
 * @author atanas.kovachev
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReporterResolverErrorComponent } from './reporter-resolver-error/reporter-resolver-error.component';
import { ErrorRoutingModule } from './error-routing.module';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  declarations: [
  ReporterResolverErrorComponent,
  NotFoundComponent],
  imports: [
    CommonModule,
    ErrorRoutingModule
  ],
  exports: [
  ],
})
export class ErrorModule {}
